import { Link } from "react-router-dom";

import type { Cart } from "@/lib/api-client";
import { Card } from "@/components/ui/Card";
import { CartTotals } from "./CartTotals";
import { CouponForm } from "./CouponForm";

// Reprend exactement les classes de `components/ui/Button.tsx` (variant
// "primary", taille "md") : ce composant `ui/` n'expose pas de rendu "as
// Link" (`asChild`), donc on applique les mêmes classes à un `<Link>` plutôt
// que de modifier ce composant partagé pour ce seul besoin.
const PRIMARY_LINK_BUTTON_CLASSES =
  "inline-flex w-full items-center justify-center gap-2 rounded-sm border border-gold bg-gold px-6 py-3 text-sm font-body font-medium uppercase tracking-wide text-navy transition-colors duration-150 hover:border-gold2 hover:bg-gold2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold aria-disabled:pointer-events-none aria-disabled:cursor-not-allowed aria-disabled:opacity-50";

export interface CartSummaryProps {
  cart: Cart;
}

/**
 * Récapitulatif collant de la page panier (VVS_MODELE_INTERFACE.md §7.2,
 * gabarit G4, colonne 4/12). Porté depuis
 * apps/web/components/cart/CartSummary.tsx — seul changement : `next/link` →
 * `react-router-dom` `Link`.
 */
export function CartSummary({ cart }: CartSummaryProps) {
  const hasUnavailableLine = cart.items.some((item) => !item.stock.inStock);

  return (
    <Card className="flex flex-col gap-4 p-4 lg:sticky lg:top-24">
      <CartTotals
        subtotalMinor={cart.subtotal.amountMinor}
        discountMinor={cart.discountTotal.amountMinor}
        shippingMinor={null}
        totalMinor={cart.total.amountMinor}
      />

      <CouponForm coupon={cart.coupon} />

      <Link
        to="/commande"
        aria-disabled={hasUnavailableLine}
        tabIndex={hasUnavailableLine ? -1 : undefined}
        className={PRIMARY_LINK_BUTTON_CLASSES}
      >
        Commander
      </Link>
      {hasUnavailableLine ? (
        <p className="text-xs text-red-700">
          Retirez les articles indisponibles pour passer commande.
        </p>
      ) : null}

      <ul className="flex flex-col gap-1 border-t border-line pt-3 text-xs text-muted">
        <li>🔒 Paiement sécurisé</li>
        <li>💵 Paiement également accepté à la livraison</li>
        <li>↩ Retours possibles après réception, sous conditions</li>
      </ul>
    </Card>
  );
}
